import FormFieldText from "../text";
import CustomFieldBase from "./base";

export default class CustomFieldText extends CustomFieldBase {
  <template>
    <FormFieldText
      ...attributes
      @name={{@field.name}}
      @title={{this.title}}
      @showTitle={{this.shouldDisplayTitle}}
      @description={{this.description}}
      @showDescription={{this.shouldDisplayDescription}}
      @placeholder={{this.placeholder}}
      @showPlaceholder={{this.shouldDisplayPlaceholder}}
      @required={{@field.required}}
      @autofocus={{@autofocus}}
      @value={{@value}}
      @onChange={{@onChange}}
      @maxLength={{this.customFieldMaxLength}}
      @validation={{@validation}}
    >
      {{yield}}
    </FormFieldText>
  </template>
}
